var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-button',{attrs:{"color":"#15c1c3"}},[_vm._v("Column Setting")]),_c('vs-button',{staticClass:"ml-3",attrs:{"color":"#15c1c3"}},[_vm._v("Filter By")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }